import { useLayoutEffect } from 'react';
import { Badge, Button, Card, Col, Form, Input, Row, Select } from 'antd';
import { observer } from 'mobx-react-lite';

import { NotificationsRender } from 'app/common/notifications/features/notifications';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';
import { CanAccess } from 'app/railways/domains/access/features/can-access';
import { TTerminalProfile } from 'app/terminals/domains/profiles/core/profiles';
import { AvailableTerminalProfiles } from 'app/terminals/domains/profiles/features/available-profiles';
import { Stack } from 'app/ui';

import { TTerminalType } from '../../core/terminal';
import { AvailableTerminalTypes } from '../available-terminal-types';

type TerminalType = Pick<TTerminalType, 'id'>;
type TerminalProfile = Pick<TTerminalProfile, 'id'>;

type FormFields = {
  type: TerminalType;
  profile?: TerminalProfile;
  blocked: boolean;
  dsn: string;
  token: string;
};

type TerminalFormProps = {
  dsnReadOnluly?: boolean;
  onSubmit?: (fields: FormFields) => void;
  values?: Partial<FormFields>;
};

const DsnValue = ({ value }: { value?: string }) => <>{value}</>;

export const TerminalForm = observer(
  ({ onSubmit, values, dsnReadOnluly = true }: TerminalFormProps) => {
    const [form] = Form.useForm();
    const notify = usePageNotify();

    useLayoutEffect(() => {
      values && form.setFieldsValue(values);
    }, [form, values]);

    return (
      <Form layout="vertical" form={form} onFinish={onSubmit}>
        <Stack>
          <Card size="small" title="Данные терминала">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="dsn"
                  label="DSN"
                  rules={[
                    {
                      required: true,
                      message: 'Пожалуйста, заполните поле',
                    },
                  ]}
                >
                  {dsnReadOnluly ? <DsnValue /> : <Input />}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="blocked"
                  label="Статус блокировки"
                  rules={[
                    {
                      required: true,
                      message: 'Пожалуйста, заполните поле',
                    },
                  ]}
                >
                  <Select style={{ width: '100%' }}>
                    <Select.Option value={false}>
                      <Badge status="success" text="Активен" />
                    </Select.Option>
                    <Select.Option value={true}>
                      <Badge status="error" text="Заблокирован" />
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="type"
                  label="Тип терминала"
                  rules={[
                    {
                      required: true,
                      message: 'Пожалуйста, заполните поле',
                    },
                  ]}
                >
                  <AvailableTerminalTypes />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="profile"
                  label="Профиль терминала"
                  rules={[
                    {
                      required: true,
                      message: 'Пожалуйста, заполните поле',
                    },
                  ]}
                >
                  <AvailableTerminalProfiles />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <NotificationsRender notifyStore={notify} />

          <CanAccess perm="PERM_TERMINAL_UPDATE">
            <Card size="small">
              <Row justify="end">
                <Button type="primary" htmlType="submit">
                  Сохранить
                </Button>
              </Row>
            </Card>
          </CanAccess>
        </Stack>
      </Form>
    );
  },
);
